// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__jjWr4","logoPlaceholder":"styles_logoPlaceholder__XANiO"};